/* Stepli size-guard (04.07.2026): wymusza swiadomy wybor rozmiaru w widgecie pakietow.
   - Wstawia placeholder "Wybierz rozmiar" do selectow options[Rozmiar] (quantity-break)
   - Blokuje ATC (glowny + sticky + submit formy) dopoki KTORYKOLWIEK WIDOCZNY select rozmiaru jest pusty
   - Czerwona ramka + komunikat; znika po wyborze
   Zdejmowanie: usunac <script> z theme.liquid — zero innych zaleznosci. */
(function () {
  'use strict';
  var MSG = 'Wybierz rozmiar dla każdej pary — w razie wątpliwości weź większy i dotnij.';
  var PLACEHOLDER = 'Wybierz rozmiar';

  function sizeSelects() {
    return Array.prototype.slice.call(
      document.querySelectorAll('select.quantity-break__variant-select[name="options[Rozmiar]"]')
    );
  }

  function ensurePlaceholders() {
    sizeSelects().forEach(function (s) {
      if (s.dataset.sizeGuard === '1') return;
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = PLACEHOLDER;
      opt.disabled = true;
      opt.hidden = true;
      s.insertBefore(opt, s.firstChild);
      s.value = '';
      s.dataset.sizeGuard = '1';
      s.addEventListener('change', function () {
        if (s.value !== '') {
          s.classList.remove('size-guard-error');
          hideMsgIfOk();
        }
      });
    });
  }

  function isReallyVisible(el) {
    /* offsetParent nie wystarcza: nieaktywne kafle bundla zwijaja .quantity-break__variants
       przez height/max-height 0, nie display:none */
    var node = el;
    while (node && node !== document.body) {
      var st = window.getComputedStyle(node);
      if (st.display === 'none' || st.visibility === 'hidden') return false;
      var h = node.getBoundingClientRect().height;
      if (h < 2 && node !== el) return false;
      node = node.parentElement;
    }
    return true;
  }

  function visibleEmpty() {
    return sizeSelects().filter(function (s) {
      return isReallyVisible(s) && s.value === '';
    });
  }

  function msgEl(create) {
    var el = document.getElementById('size-guard-msg');
    if (!el && create) {
      el = document.createElement('div');
      el.id = 'size-guard-msg';
      el.className = 'size-guard-msg';
      el.setAttribute('role', 'alert');
      el.textContent = MSG;
      var anchor = document.querySelector('.quantity-break__container, quantity-breaks, [class*="quantity-break"]');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(el, anchor);
      else return null;
    }
    return el;
  }

  function hideMsgIfOk() {
    if (visibleEmpty().length === 0) {
      var el = document.getElementById('size-guard-msg');
      if (el) el.style.display = 'none';
    }
  }

  function guard(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('button[type="submit"], .main-product-atc, [id^="sticky-atc"] button, .sticky-atc button');
    if (!btn) return;
    var form = btn.closest('form');
    var inProductForm = (form && /\/cart\/add/.test(form.getAttribute('action') || '')) || btn.className.indexOf('atc') !== -1 || btn.closest('[id^="sticky-atc"], .sticky-atc');
    if (!inProductForm) return;
    var empty = visibleEmpty();
    if (empty.length === 0) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    empty.forEach(function (s) { s.classList.add('size-guard-error'); });
    var el = msgEl(true);
    if (el) el.style.display = 'block';
    try { empty[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { empty[0].scrollIntoView(); }
  }

  function init() {
    if (!sizeSelects().length) return;
    ensurePlaceholders();
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && /\/cart\/add/.test(form.getAttribute('action') || '') && visibleEmpty().length) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    var container = document.querySelector('[class*="quantity-break"]');
    if (container && window.MutationObserver) {
      new MutationObserver(function () { ensurePlaceholders(); }).observe(
        container.closest('form') || container.parentNode || container,
        { childList: true, subtree: true }
      );
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
